import React, { useState } from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { VIEW_SERVICE_REQUEST_LABELS as L } from '../../constants/labels';
import type { ViewServiceRequestDetail } from '../../types/viewServiceRequestType';
import { orDash } from './viewServiceRequestHelpers';
import { SectionCard } from './viewServiceRequestUI';

interface SREquipmentTabProps {
  detail: ViewServiceRequestDetail | undefined;
}

const SREquipmentTab: React.FC<SREquipmentTabProps> = ({ detail }) => {
  const [equipmentImageError, setEquipmentImageError] = useState(false);
  const hasEquipment = !!(detail?.equipment_id || detail?.equipment_name);

  return (
    <div className="flex flex-col gap-6 flex-1">
      <SectionCard
        title={L.SECTION_EQUIPMENT_DATA}
        testId="view-sr-section-equipment-data"
        {...(hasEquipment ? {} : { className: 'flex-1' })}
      >
        {hasEquipment ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#F2F4F5]">
                  <th className="text-left text-body-medium text-[#474A4C] font-medium py-2.5 px-[20px] rounded-l-[4px]">
                    {L.FIELD_EQUIPMENT_NAME}
                  </th>
                  <th
                    className="text-left text-body-medium
                   text-[#474A4C] font-medium py-2.5 px-[20px] rounded-r-[4px]"
                  >
                    {L.FIELD_EQUIPMENT_ID}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr data-testid="view-sr-equipment-row">
                  <td className="py-3 px-3">
                    <div className="flex items-center gap-3">
                      {detail?.equipment_image?.url && !equipmentImageError ? (
                        <img
                          src={detail.equipment_image.url}
                          alt={detail.equipment_name ?? ''}
                          className="w-8 h-8 rounded-full object-cover shrink-0"
                          onError={() => setEquipmentImageError(true)}
                        />
                      ) : (
                        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#F3F4F6] shrink-0">
                          <WrenchScrewdriverIcon className="w-4 h-4 text-[#474A4C]" />
                        </span>
                      )}
                      <span
                        className="font-normal text-[#181A1B] break-words"
                        data-testid="view-sr-equipment-name"
                      >
                        {orDash(detail?.equipment_name)}
                      </span>
                    </div>
                  </td>
                  <td
                    className="py-3 px-3 text-[#474A4C] align-middle"
                    data-testid="view-sr-equipment-id"
                  >
                    {orDash(detail?.equipment_id)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div
            className="border border-[#DCDDE0] rounded-[8px] px-5 py-3.5 flex items-center justify-center"
            data-testid="view-sr-equipment-empty"
          >
            <p className="text-bodyMedium text-on-surface-variant text-center">
              {L.EMPTY_EQUIPMENT_MESSAGE}
            </p>
          </div>
        )}
      </SectionCard>
    </div>
  );
};

export default SREquipmentTab;
